import React from "react";
import SectionShell from "../components/sections/SectionShell";
import { resolveSectionTab } from "../components/sections/sectionTabs";
import AdminMigrationTools from "../components/AdminMigrationTools";
import PlatformConnections from "../components/PlatformConnections";
import MuxSettings from "../components/settings/MuxSettings";
import BrandSettings from "../components/settings/BrandSettings";
import AISettings from "./AISettings";
import RolesPage from "./crm/RolesPage";
import ActivityLog from "./crm/ActivityLog";

// One Settings hub. Every tab has its own ?tab=<id> URL so the selected tab
// survives refresh, deep links and back/forward navigation.
export const SETTINGS_TABS = [
  { id: "connections", label: "Platform Connections", icon: "🔌", render: () => <PlatformConnections /> },
  { id: "ai", label: "AI", icon: "✨", render: () => <AISettings /> },
  { id: "mux", label: "Mux Video", icon: "🎬", render: () => <MuxSettings /> },
  { id: "brand", label: "Brand & Theme", icon: "🎨", render: () => <BrandSettings /> },
  { id: "roles", label: "Roles & Permissions", icon: "👥", render: () => <RolesPage /> },
  { id: "activity", label: "Activity Log", icon: "📜", render: () => <ActivityLog /> },
  { id: "admin", label: "Admin Tools", icon: "🛠️", render: () => <div className="max-w-4xl" data-testid="settings-admin-tab"><AdminMigrationTools /></div> },
  { id: "email", label: "Email sending", icon: "✉️", href: "/crm/email" },
];

export const SETTINGS_TAB_ALIASES = { theme: "brand", design: "brand", "design-settings": "brand", permissions: "roles", "ai-settings": "ai" };

// Unknown/missing -> connections; old ids (theme) map to their new tab.
export function resolveSettingsTab(value) {
  return resolveSectionTab(SETTINGS_TABS, value, SETTINGS_TAB_ALIASES);
}

export default function Settings() {
  return (
    <SectionShell
      sectionId="settings"
      title="Settings"
      overline="CONNECTIONS · AI · BRAND · TEAM · ADMIN"
      tabs={SETTINGS_TABS}
      aliases={SETTINGS_TAB_ALIASES}
    />
  );
}
